import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/form.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { store,persistor } from "./redux/store"; // Import your Redux store

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {/* Wrap the entire app with AuthProvider to enable global authentication state */}
    <AuthProvider>
      {/* Wrap the entire app with Provider to enable Redux store access */}
      <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <App />
        </PersistGate>
      </Provider>
    </AuthProvider>
  </>
);

// Optional: Measure app performance (e.g., with Google Analytics)
reportWebVitals();
